/* Component Dependencies */
var meetingRoomSetupTemplate = require('templates/meetingRoomSetup.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'meetingRoomSetup',
  template: {
    'meetingRoomSetup': meetingRoomSetupTemplate
  }
});
